<div class="container-fluid">
  <form class="form-horizontal" #f="ngForm">
    <div class="field-container">
      <div class="form-group">
        <label class="col-sm-2 control-label">
          Réf. ICMA
        </label>
        <div class="col-sm-4">
          <input class="form-control"
            [readonly]="mode === 'normal'" name="reference_icma" [(ngModel)]="woi.metadata.reference_icma" />
        </div>

        <label class="col-sm-2 control-label">
          Réf. DT
        </label>
        <div class="col-sm-4">
          <input class="form-control"
            [readonly]="mode === 'normal'" name="reference_dt" [(ngModel)]="woi.metadata.reference_dt" />
        </div>
      </div>
    </div>

    <hr />

    <div class="form-group">
      <label class="col-md-4 col-lg-2 control-label">
        Numéro de série
      </label>
      <div class="col-md-8 col-lg-4">
        <div class="input-group">
          <input #serialNumberInput
                 autofocus
                 class="form-control"
                 name="serialNumber"
                 [(ngModel)]="serialNumber"
                 [disabled]="woi.state?.name === 'cancelled' || woi.state?.name === 'done'" />
          <div class="input-group-btn">
            <button type="submit"
                    class="btn btn-default"
                    [disabled]="loading || woi.state?.name === 'cancelled' || woi.state?.name === 'done'"
                    (click)="searchForSerial()">
              <i class="fa fa-spinner fa-spin" [hidden]="!loading"></i> Rechercher
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="wcm-table-header" data-testid="neylu-scanned-equipment-header">
      <nav class="navbar navbar-default">
        <div class="container-fluid">
          <div class="navbar-header">
            <a class="navbar-brand">
              Équipements à retourner ({{ items.length }})
            </a>
          </div>

          <div class="collapse navbar-collapse">
            <form class="navbar-form navbar-right action-btn-bar">
              <app-reminder-email-button *hasPermissions="'Antoine:WorkOrderItemCanSendMail'"
                                         type="recovery"
                                         label="Envoyer une relance"
                                         [woi]="woi"
                                         [disabled]="mode !== 'normal'">
              </app-reminder-email-button>

              <button type="button" class="btn btn-default"
                      [disabled]="scannedEquipmentExportService.isLoading$ | async"
                      (click)="scannedEquipmentExportService.triggerExport(woi)">
                <i class="far fa-file-excel"></i> Exporter
              </button>

              <button class="btn btn-default"
                      [disabled]="mode !== 'normal'"
                      (click)="openAddExistingEquipmentModal()">
                <i class="fas fa-plus" aria-hidden="true"></i> Ajouter des équipements
              </button>

              <button class="btn btn-default"
                      [disabled]="mode !== 'normal'"
                      (click)="openAddEquipmentLineModal()">
                <i class="fas fa-plus" aria-hidden="true"></i> Ajouter des lignes de matériel
              </button>
            </form>
          </div>
        </div>
      </nav>
    </div>

    <p-table #table
             class="wcm-table scanned-equipment"
             data-testid="neylu-scanned-equipment-table"
             [rows]="items.length"
             [value]="items"
             [reorderableColumns]="true"
             [scrollable]="true">

      <ng-template pTemplate="header">
        <tr data-testid="neylu-scanned-equipment-columns">
          <th>Code</th>
          <th>Constructeur</th>
          <th>Modèle</th>
          <th>N° de série</th>
          <th>Client</th>
          <th>Affectation</th>
          <th>Type</th>
          <th>Statut</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
        <tr class="border {{ item.scan_status }}" data-testid="neylu-scanned-equipment-row">

          <td class="no-text-wrap">
            <a *ngIf="item.code" routerLink="/equipments/detail/{{ item.code }}" target="_blank">
              <i class="fas fa-external-link-alt" aria-hidden="true"></i> {{ item.code }}
            </a>
          </td>

          <td class="text-center no-text-wrap">{{ item.model?.brand?.name }}</td>

          <td class="text-center no-text-wrap">{{ item.model?.name }}</td>

          <td class="text-center no-text-wrap">{{ item.serial_number }}</td>

          <td class="no-text-wrap">
            <a *ngIf="item.entity?.code" routerLink="/entities/detail/{{ item.entity?.code }}" target="_blank">
              <i class="fas fa-external-link-alt" aria-hidden="true"></i> {{ item.entity?.name }}
            </a>
          </td>

          <td class="text-center no-text-wrap">{{ locationOptions[item.location] }}</td>

          <td class="text-center no-text-wrap">{{ item.model?.type_label }}</td>

          <td class="text-center no-text-wrap">
            <ng-container [ngSwitch]="item.scan_status">
              <img *ngSwitchCase="'scanned'" alt="success" ngSrc="assets/img/icon_check.svg" width="20" height="20" />
              <i *ngSwitchCase="'added'" class="fas fa-plus-circle fa-lg wcm-info" aria-label="added" aria-hidden="true"></i>
              <img *ngSwitchDefault alt="unknown" ngSrc="assets/img/icon_unknown.svg" width="20" height="20" />
            </ng-container>
          </td>

          <td class="text-center no-text-wrap">
            <div class="action-btn-bar">
              <button class="btn btn-default btn-xs"
                      type="button"
                      title="Réinitialiser la ligne"
                      [disabled]="mode !== 'normal'"
                      (click)="resetLineScan(rowIndex)">
                <i class="fas fa-undo-alt"></i>
              </button>
            </div>
          </td>

          <td class="text-center no-text-wrap">
            <div class="action-btn-bar">
              <button class="btn btn-default btn-xs"
                      type="button"
                      title="Supprimer"
                      [disabled]="mode !== 'normal'"
                      (click)="removeEquipmentRow(rowIndex)">
                <i class="fa fa-trash-alt"></i>
              </button>
            </div>
          </td>

        </tr>
      </ng-template>
    </p-table>
  </form>
</div>
